var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amount-number"},[_c('span',[_vm._v(_vm._s(_vm.amountFormatValue(_vm.amountCurrent).split('.')[0]))]),_vm._v("."+_vm._s(_vm.amountFormatValue(_vm.amountCurrent).split('.')[1])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }